import { FuturesAdjustLotListView, FuturesBankCostChangeListView } from './FuturesAdjustBankCostListViews'
import { FuturesLocalPListView, FuturesLocalSListView } from './FuturesLocalListViews'

interface Props {
  kind: 'adjust-lot' | 'bank-cost-change' | 'pucontract' | 'local-s'
  embedded?: boolean
}

/** List + CRUD Futures — SQL khớp `query_FuturesQry*.txt` (backend `futures_control_service.py`).
 *  Date filter (PU: `local_p.latest_delivery`, SA: `local_s.delivery_from`) đọc trực tiếp
 *  từ `user_preferences` server-side — không truyền qua props.
 */
export default function FuturesGenericListView({ kind, embedded }: Props) {
  switch (kind) {
    case 'pucontract':
      return <FuturesLocalPListView embedded={embedded} />
    case 'local-s':
      return <FuturesLocalSListView embedded={embedded} />
    case 'adjust-lot':
      return <FuturesAdjustLotListView embedded={embedded} />
    case 'bank-cost-change':
      return <FuturesBankCostChangeListView embedded={embedded} />
    default:
      return null
  }
}
